import request from 'helper/NetworkLayer';
import { DueDateTypeEnumLowercase } from '../appConsts';

export default function enrolUserContent(contentId, userId, companyId, dontSendAuthHeader) {
  // window.analytics && window.analytics.track('CONTENT_AUTO_ASSIGN_EVENT', {
  //   assignerId: userId,
  //   companyId,
  //   activityId: contentId
  // });
  const requestData = {
    type: 'assignContent',
    assignContentParams: {
      userId,
      assignerId: userId,
      companyId,
      creatorId: userId,
      timeStamp: new Date().toISOString(),
      contentIds: [contentId],
      assignType: 'enrolled',
      unitSettings: [
        {
          unitId: contentId,
          dueDateDetails: {
            type: DueDateTypeEnumLowercase.noDueDate
          }
        }
      ]
    },
    sync: true
  };

  return request(
    '/syncMutations',
    {
      method: 'POST',
      body: JSON.stringify(requestData)
    },
    {
      removeApiEndpoint: true,
      dontSendAuthHeader: typeof dontSendAuthHeader !== 'boolean' ? false : dontSendAuthHeader
    }
  );
}
